import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  Typography,
  CardContent,
  CardActionArea
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { useHistory } from 'react-router-dom';
import * as ROUTES from '../../constants/routes';
import useStyles from './styles.js';

const NewTranscriptCard = ({ disabled }) => {
  const classes = useStyles();
  const history = useHistory();
  const handleClick = () => {
    if (!disabled) {
      history.push(ROUTES.NEW_TRANSCRIPT);
    }
  };
  return (
    <CardActionArea className={classes.cardActionArea} onClick={handleClick}>
      <Card className={classes.card}>
        <CardContent className={classes.newTranscriptContainer}>
          <AddIcon
            fontSize={'large'}
            className={classes.addIcon}
            color="primary"
          />
          <Typography
            className={classes.title}
            color="primary"
            variant="h6"
            component="h2"
          >
            {disabled
              ? 'Change your plan to add more Transcripts'
              : 'Add new Transcript'}
          </Typography>
        </CardContent>
      </Card>
    </CardActionArea>
  );
};
NewTranscriptCard.propTypes = {
  disabled: PropTypes.bool
};

export default NewTranscriptCard;
